<template>
  <div>
    <Carousel
      :autoplay="true"
      :loop="true"
      :per-page="1"
      :navigation-enabled="true"
      :scroll-per-page="true"
      :pagination-enabled="false"
      :speed="1500"
      :autoplay-timeout="5000"
    >
      <Slide v-for="(slide, k) in slides" v-cloak :key="k">
        <figure v-if="slide.image" class="image">
          <img :src="slide.image" />
        </figure>
        <div
          :class="slide.image ? '' : 'VueCarousel-slide-caption--no-image'"
          class="VueCarousel-slide-caption ql-editor"
        >
          <div class="VueCarousel-slide-caption--body" v-html="slide.body" />
          <div class="VueCarousel-slide-caption--action ">
            <a
              :href="slide.path"
              :class="
                slide.buttonClass ? slide.buttonClass : 'is-success is-large'
              "
              class="button"
              style="font-size: 1.2vw"
              v-html="slide.buttonText"
            />
          </div>
        </div>
      </Slide>
    </Carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'IndexSlides',

  components: {
    Carousel,
    Slide
  },

  props: {
    slides: { required: true, type: Array }
  }
};
</script>
